<template>
  <v-tooltip location="top">
    <template #activator="{ props }">
      <span
        v-if="claim.passengers && claim.passengers.length"
        v-bind="props"
      >{{
        claim.passengers.join(", ")
      }}</span>
      <em v-else>{{ $t("previewApplicationPageStrings.noPassengers") }}</em>
    </template>
    <ul>
      <li
        v-for="(name, index) in claim.passengers"
        :key="index"
      >
        {{ name }}
      </li>
    </ul>
  </v-tooltip>
</template>

<script>
export default {
  name: "TripPassengersWithTooltip",
  props: {
    claim: {
      required: true
    }
  }
};
</script>
